<template>
  <v-dialog v-model="show" persistent>
    <v-card class="py-4 px-3" v-if="firstPanel">
      <v-layout align-center column>
        <img width="30%" src="../../assets/icons/icon-values.png" />
      </v-layout>
      <v-layout mx-3 align-start column>
        <span class="pt-3 subheading font-weight-medium"
          >Sobre os valores e caução</span
        >
        <span class="pt-4 body-2 font-weight-regular"
          >Ao realizar uma reserva, será cobrado o valor correspondente ao tempo
          agendado. Além disso, iremos solicitar junto a sua operadora de cartão
          de crédito, caucionamento de valor que será usado durante o checkout
          para cobrança da quilometragem e outros custos que podem vir a
          acontecer.</span
        >
        <span class="pt-4 body-2 font-weight-regular"
          >O valor excedente será liberado e os prazos para restauração do seu
          limite dependerá da sua operadora de cartão.</span
        >
      </v-layout>
      <v-layout mx-3 align-center column text-center>
        <img class="nextStep-icon" src="../../assets/icons/icon-step1.png" />
      </v-layout>
      <v-btn @click="nextPanel(2)" class="nextStep ma-0 w-100 mt-5">
        <span class="white--text font-weight-bold">PRÓXIMO</span>
      </v-btn>
    </v-card>

    <v-card class="py-4 px-3" v-if="secondPanel">
      <v-layout align-center column>
        <img width="30%" src="../../assets/icons/icon-credit-card.png" />
      </v-layout>
      <v-layout mx-3 align-start column>
        <span class="pt-3 subheading font-weight-medium"
          >Sobre o abastecimento</span
        >
        <span class="pt-4 body-2 font-weight-regular"
          >O cartão de combustível fica no porta-luvas do veículos, juntamente
          com a senha/matrícula. Ele aceita apenas abastecimento no ÁLCOOL.
          Abastecimentos realizados em gasolina não serão reembolsado.</span
        >
        <span class="pt-4 body-2 font-weight-regular"
          >Caso aconteça algum problema e não consiga abastecer no cartão de
          combustível, peça ao frentista o cupom fiscal e solicite o reembolso
          pelo app durante o processo de checkout.</span
        >
      </v-layout>
      <v-layout mx-3 align-center column text-center>
        <img class="nextStep-icon" src="../../assets/icons/icon-step2.png" />
      </v-layout>
      <v-btn @click="nextPanel(3)" class="nextStep ma-0 w-100 mt-5">
        <span class="white--text font-weight-bold">PRÓXIMO</span>
      </v-btn>
    </v-card>

    <v-card class="py-4 px-3" v-if="thirdPanel">
      <v-layout align-center column>
        <img width="30%" src="../../assets/icons/icon-tolerance.png" />
      </v-layout>
      <v-layout mx-3 align-start column>
        <span class="pt-3 subheading font-weight-medium"
          >Sobre os prazos e tolerâncias</span
        >
        <span class="pt-4 body-2 font-weight-regular"
          >Você pode realizar o cancelamento da sua reserva com até 15 minutos
          de antecedência, nesses casos, realizamos o estorno integral do valor
          da reserva. O estorno é realizado na hora, porém, o prazo para
          refletir em sua fatura, dependerá exclusivamente da sua operadora de
          cartão de crédito.</span
        >
        <span class="pt-4 body-2 font-weight-regular"
          >O checkin pode ser feito com até 10 minutos de antecedência, desde
          que o veículo esteja na garagem. Assim como o checkin, concedemos 10
          minutos de tolerância de atraso para o checkout, porém, caso essa
          tolerância seja ultrapassada, para garantirmos que o próximo motorista
          não seja impactado, uma multa de atraso será aplicada.</span
        >
      </v-layout>
      <v-layout mx-3 align-center column text-center>
        <img class="nextStep-icon" src="../../assets/icons/icon-step3.png" />
      </v-layout>
      <v-btn @click="$emit('close')" class="nextStep ma-0 w-100 mt-5">
        <span class="white--text font-weight-bold">LI E CONCORDO</span>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      firstPanel: true,
      secondPanel: false,
      thirdPanel: false,
    };
  },

  props: {
    show: Boolean,
    date: String,
  },

  methods: {
    async nextPanel(step) {
      this.firstPanel = step === 1;
      this.secondPanel = step === 2;
      this.thirdPanel = step === 3;
    },
  },
};
</script>

<style scoped>
.float {
  position: absolute;
  top: 5px;
  right: 5px;
}

.nextStep {
  background-color: var(--secondary-color) !important;
  margin-top: 20px !important;
}

.nextStep-icon {
  margin-top: 20px !important;
}
</style>
